import { API_URL } from '@/shared/utils/apiConfig';

const SIGNED_AVATAR_MARKER = '/files/avatars/';

export const isSignedAvatarApiPath = (apiPath: string): boolean =>
  apiPath.includes(SIGNED_AVATAR_MARKER);

const isAbsoluteOrInline = (apiPath: string): boolean =>
  apiPath.startsWith('blob:') ||
  apiPath.startsWith('data:') ||
  apiPath.startsWith('http://') ||
  apiPath.startsWith('https://');

/** True when the browser can load the src without an Authorization header. */
export const isBrowserNativeAvatarSrc = (apiPath: string): boolean =>
  isAbsoluteOrInline(apiPath) || isSignedAvatarApiPath(apiPath);

/**
 * Resolve MUI Avatar `src`: signed `/files/avatars/` paths become absolute API URLs;
 * authenticated paths stay on the blob object URL from `useAuthenticatedObjectUrl`.
 */
export const resolveAvatarImgSrc = (
  apiSrc: string | null | undefined,
  options: { objectUrl?: string | null; fallbackSrc?: string } = {}
): string | undefined => {
  const { objectUrl, fallbackSrc } = options;
  if (!apiSrc) return fallbackSrc;

  if (isAbsoluteOrInline(apiSrc)) return apiSrc;

  if (isSignedAvatarApiPath(apiSrc)) {
    const path = apiSrc.startsWith('/') ? apiSrc : `/${apiSrc}`;
    return `${API_URL}${path}`;
  }

  return objectUrl || fallbackSrc;
};
